import React, { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom';
import Subscriber from './Subscriber';
// import ViewPatients from '../../Portals/patients/ViewPatients';

const ViewPatients = lazy(() => import('../../Portals/patients/ViewPatients'));
const ViewNewsletter = lazy(() => import('../../Portals/patients/ViewNewsletter'));
const ViewSavedList =lazy(()=>import('../../Portals/patients/ViewSavedList'));
const ViewDetails =lazy(()=>import('../../Portals/patients/ViewDetails'))
const ViewPatientDetails =lazy(()=>import('../../Portals/patients/PatientDetails'))
function patientsModule() {
  return (
    <div>
      
       <Suspense fallback={null}>
       <Routes>
         <Route path="viewPatients" element={<ViewPatients />} />
         <Route path="viewPatients/viewNewsletter" element={<ViewNewsletter />} />
         <Route path="viewPatients/viewSavedList" element={<ViewSavedList />} />
         <Route path="viewPatients/viewReadHistory" element={<ViewSavedList />} />
         <Route path="viewPatients/ViewDetails" element={<ViewDetails />} />
         <Route path="viewPatients/viewPatientDetails" element={<ViewPatientDetails />} />
         <Route path="viewSubscriber" element={<Subscriber />} />
        </Routes>
        </Suspense>
    </div>
  )
}

export default patientsModule
